import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Body.css";

function OrderingExample() {
  return (
    <Container body-wrapper>
      <h2>React <strong> CHATBOT </strong></h2>
      <Row style={{ gridGap: "35px" }} className="body-row">
        <Col xs className="box">
          This is a simple chatGPT replica, built by <strong><a target="_blank" href="https://github.com/fafo-hub">ME.</a></strong>
        </Col>
        <Col xs={{ order: 12 }} className="box">
          openAI API was consumed to receive prompts from users.
        </Col>
        <Col xs={{ order: 1 }} className="box">
          The API then respond with the best possible answer it can give.
        </Col>
      </Row>{" "}
      
      <Row style={{ gridGap: "35px", marginTop: '30px' }} className="body-row">
        <Col xs className="box">
        It was build using HTML5, CSS3, React Bootstrap and ReactJS for the frontend
        </Col>
        <Col xs={{ order: 12 }} className="box">
          NodeJS, Express for the backend
        </Col>
        <Col xs={{ order: 1 }} className="box">
          And lastly, Firebase was used for the Google Auth.
        </Col>
      </Row>
    </Container>
  );
}

export default OrderingExample;
